import 'css-chunksrc/client/pages/planzoneMembersPage/groupsList/placeholder/styles.scss';export default {
  "placeholder": "_placeholder_1qmxd_1",
  "button": "_button_1qmxd_23"
};